import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule } from '@spartacus/core';
import { IconModule, MediaModule } from '@spartacus/storefront';
import { CoreSearchModule } from './core-search/core-search.module';
import { KbMyOwnPartNumbersModule } from './kb-MyOwnPartNumbers/kbMyOwnPartNumbers.module';
import { KbMyPriceListModule } from './kb-MyPriceList/kb-my-price-list.module';
import { KbMyBulletinBoardModule } from './kb-my-Bulletins/kbMybulletinBoard.module';
import { KbMyTicketsModule } from './kb-my-Tickets/kbMytickets.module';
import { KbMyProfileModule } from './kb-my-profile/kb-my-profile.module';
import { KbMyAddressBookModule } from './kb-myAddressBook/kbMyAddressbook.module';
import { KbPositionModule } from './kb-open-position/kb-position.module';
import { KbSubmitWarrantyClaimModule } from './kb-submit-warranty-claim/kb-submit-warranty-claim.module';
import { SearchWarrantyClaimModule } from './warranty-search/warranty-search.module';
import { KbReturnRequestModule } from './kb-returnRequest/kb-return-request.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    IconModule,
    I18nModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MediaModule,
    KbMyProfileModule,
    KbReturnRequestModule,
    KbSubmitWarrantyClaimModule,
    SearchWarrantyClaimModule,
    KbMyOwnPartNumbersModule,
    KbMyPriceListModule,
    KbMyTicketsModule,
    KbMyBulletinBoardModule,
    KbMyAddressBookModule,
    CoreSearchModule,
    KbPositionModule
  ],
})
export class KbMyAccountModule { }
